import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import InventoryPage from "@/pages/InventoryPage";
import SoldInventoryPage from "@/pages/SoldInventoryPage";
import VehicleDetailPage from "@/pages/VehicleDetailPage";
import FinancingPage from "@/pages/FinancingPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import NotFoundPage from "@/pages/NotFoundPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminInventory from "@/pages/admin/AdminInventory";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminHomepage from "@/pages/admin/AdminHomepage";
import AdminNavigation from "@/pages/admin/AdminNavigation";
import AdminPages from "@/pages/admin/AdminPages";
import AdminDesign from "@/pages/admin/AdminDesign";
import AdminSEO from "@/pages/admin/AdminSEO";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminSettings from "@/pages/admin/AdminSettings";

const SiteLayout = () => (
  <div className="min-h-screen bg-background text-foreground">
    <Navbar />
    <Outlet />
    <Footer />
  </div>
);

function App() {
  return (
    <SiteProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/inventory" element={<InventoryPage />} />
              <Route path="/inventory/sold" element={<SoldInventoryPage />} />
              <Route path="/vehicles/:id" element={<VehicleDetailPage />} />
              <Route path="/financing" element={<FinancingPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminDashboard />} />
              <Route path="inventory" element={<AdminInventory />} />
              <Route path="categories" element={<AdminCategories />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="website/homepage" element={<AdminHomepage />} />
              <Route path="website/navigation" element={<AdminNavigation />} />
              <Route path="website/pages" element={<AdminPages />} />
              <Route path="website/design" element={<AdminDesign />} />
              <Route path="website/seo" element={<AdminSEO />} />
              <Route path="media" element={<AdminMedia />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </SiteProvider>
  );
}

export default App;
